export class DeskType {

    private internalId: string;
    private typeCode: string;
    private typeName: string;

    constructor(internalId?: string, typeCode?: string, typeName?: string) {
        this.internalId = internalId;
        this.typeCode  = typeCode;
        this.typeName = typeName;
    }

    public get InternalId() {
        return this.internalId;
    }
    public get TypeCode() {
        return this.typeCode;
    }
    public get TypeName() {
        return this.typeName;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set TypeCode(typeCode) {
        this.typeCode = typeCode;
    }
    public set TypeName(typeName) {
        this.typeName = typeName;
    }
}
